import { Modal } from 'antd';
import React, { useState } from 'react';
import { LoadingOutlined } from "@ant-design/icons";

const ImageViewer = ({
    visible = false,
    title= "Quick View",
    imgUrl = "",
    height = "100%",
    width = "100%",
    loading = false,
    hideModal = () => { }
}) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    return (
        <Modal className="img-viewer-modal" width={width} title={title} open={visible} onCancel={hideModal} footer={null}>
            {
                loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        {antIcon}
                    </div>
                ) :
                    <div style={{ display: 'flex', justifyContent: 'center', width, height, margin: '0 auto', padding: 8 }}>
                        <img src={imgUrl} alt="" style={{ width: '100%', height: '100%' }} />
                    </div>
            }
        </Modal>
    )
};

export default ImageViewer;